export default __webpack_public_path__ + "static/media/slider2.a41ff200.jpeg";